import {FC} from 'react'
import {storeBooking} from "../../lib/booking";
import CheckBox from "../common/Checkbox/Checkbox";
import {formatSlug} from "../../lib/helpers";

interface Props {
    option:any,
    booking:Booking,
    setBooking:Function
}

const VW: FC<Props> = ({option, booking, setBooking}) => {

    const debug = false
    const handleCheckBox = (box:string, value:any) => {
        booking.options_extra.vw_connect = value
        storeBooking(booking, setBooking)
    }

    if(!debug) {
        if (booking.booking_flow === 'hjulskifte' || formatSlug(booking.car.brand) !== 'volkswagen' || !option.active) {
            return
        }

        // Do not show option for pts when booking only includes hjulskifte (service product)
        if (booking.service.slug.includes('hjulskifte')) {
            return
        }
    }

    return (
        <>
            <ul className="wco-order-options_list brand-extra-option">
                <li className="volvo-mechanic input-outer chk-box">
                    <div className="li-text">
                        <div className="description">
                            <h3>{option.header}</h3>
                            {option.description}
                        </div>
                        <div>
                            <CheckBox title={option.choice} active={booking.options_extra.vw_connect} type={'vw'} handle={handleCheckBox}/>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
};

export default VW
